/**
 * Presets de classes para os componentes de orçamento funcionarem tanto na
 * landing (tema claro) quanto no painel admin (tema escuro) sem duplicar JSX.
 */
export type Tone = "light" | "dark";

export const tones = {
  light: {
    card: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm",
    eyebrow: "text-xs font-bold uppercase tracking-[0.2em] text-primary",
    title: "text-lg font-bold text-slate-900",
    label: "text-sm font-semibold text-slate-700",
    hint: "text-xs text-slate-500",
    text: "text-slate-900",
    muted: "text-slate-500",
    input:
      "h-11 w-full min-w-0 rounded-xl border border-slate-200 bg-white px-3 text-sm text-slate-900 placeholder:text-slate-400 transition focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30",
    textarea:
      "w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 transition focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30",
    dropdown: "border-slate-200 bg-white shadow-xl",
    group: "bg-slate-50 text-slate-400",
    option: "text-slate-800 hover:bg-primary/5 data-[active=true]:bg-primary/10",
    optionMuted: "text-slate-400",
    chip: "border-slate-200 bg-slate-50 text-slate-700",
    chipActive: "border-primary bg-primary/10 text-primary",
    stepperButton:
      "h-11 w-11 rounded-xl border border-slate-200 bg-white text-slate-700 transition hover:border-primary hover:text-primary disabled:opacity-40",
    toggle: "border-slate-200 bg-slate-50",
    toggleActive: "border-primary bg-primary text-white",
    toggleInactive: "text-slate-600 hover:text-primary",
    divider: "border-slate-200",
    summary: "rounded-2xl border border-slate-200 bg-white p-5 shadow-xl ring-1 ring-slate-100",
    summaryTotal: "text-slate-900",
    badge: "bg-primary/10 text-primary",
    badgeWarn: "bg-amber-100 text-amber-800",
    bar: "border-slate-200 bg-white/95 text-slate-900 shadow-[0_-8px_30px_rgba(15,23,42,0.08)]",
  },
  dark: {
    card: "rounded-3xl border border-white/10 bg-white/5 p-4",
    eyebrow: "text-xs font-semibold uppercase tracking-[0.4em] text-white/50",
    title: "text-base font-semibold text-white",
    label: "text-xs uppercase tracking-[0.3em] text-white/50",
    hint: "text-xs text-white/50",
    text: "text-white",
    muted: "text-white/60",
    input:
      "h-10 w-full min-w-0 rounded-2xl border border-white/10 bg-white/5 px-3 text-sm text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-primary/40",
    textarea:
      "w-full rounded-2xl border border-white/10 bg-white/5 px-3 py-2 text-sm text-white placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-primary/40",
    dropdown: "border-white/10 bg-slate-900 shadow-2xl",
    group: "bg-white/5 text-white/40",
    option: "text-white/90 hover:bg-white/10 data-[active=true]:bg-white/10",
    optionMuted: "text-white/40",
    chip: "border-white/10 bg-white/5 text-white/80",
    chipActive: "border-primary bg-primary/20 text-white",
    stepperButton:
      "h-10 w-10 rounded-xl border border-white/10 bg-white/5 text-white transition hover:bg-white/10 disabled:opacity-40",
    toggle: "border-white/10 bg-white/5",
    toggleActive: "border-primary bg-primary text-primary-foreground",
    toggleInactive: "text-white/60 hover:text-white",
    divider: "border-white/10",
    summary: "rounded-3xl border border-white/10 bg-white/5 p-4",
    summaryTotal: "text-primary",
    badge: "bg-primary/20 text-primary",
    badgeWarn: "bg-amber-500/20 text-amber-200",
    bar: "border-white/10 bg-slate-950/95 text-white",
  },
} as const;

export type ToneClasses = (typeof tones)[Tone];
